import * as React from 'react';
import type { SVGProps } from 'react';
const SvgPageview = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={12}
    fill="none"
    viewBox="0 0 16 12"
    {...props}
  >
    <path
      fill="#999"
      d="M10.813 12H1.5a1.44 1.44 0 0 1-1.052-.448A1.44 1.44 0 0 1 0 10.5v-9Q0 .896.448.448A1.44 1.44 0 0 1 1.5 0h13q.619 0 1.06.448Q16 .897 16 1.5v9q0 .605-.44 1.052A1.43 1.43 0 0 1 14.5 12h-1.562l-3.98-4a4 4 0 0 1-.824.365q-.428.135-.884.135-1.354 0-2.302-.948T4 5.25t.948-2.302T7.25 2t2.302.948q.948.949.948 2.302 0 .458-.125.893a3 3 0 0 1-.375.815l3.563 3.542h.937v-9h-13v9h7.813zM7.246 7a1.7 1.7 0 0 0 1.244-.506Q9 5.987 9 5.254a1.7 1.7 0 0 0-.506-1.244q-.507-.51-1.24-.51a1.7 1.7 0 0 0-1.244.506q-.51.507-.51 1.24t.506 1.244q.507.51 1.24.51"
    />
  </svg>
);
export default SvgPageview;
